import { mixinFreeColor } from './mixinVars';
export const blackVars = {
    // 工作桌面导航背景颜色
    '--workbench-nav-bg-color': '#35353c',
    // 工作桌面导航栏应用菜单扇叶颜色
    '--workbench-nav-allapps-color': '#e04340',
    // 工作桌面导航栏应用菜单扇叶hover颜色
    '--workbench-nav-allapps-hover-color': '#e04340',
    // 面包屑文字颜色 
    '--workbench-nav-breadcrumb-color': '#a0a1a1',
    // 面包屑中间箭头颜色
    '--workbench-nav-breadcrumb-color1': '#888c95',
    // 面包屑hover底色
    '--workbench-nav-breadcrumb-hover-bg-color': '#4a5160',
    // 面包屑当前节点文字颜色
    '--workbench-nav-breadcrumb-current-color': '#ddd',
    // 工作桌面导航栏搜索框hover边框颜色
    '--workbench-search-app-hover-border-color': '#39393f',
    // 工作桌面导航栏搜索框hover背景色
    '--workbench-search-app-hover-bg-color': '#34343c',
    // 工作桌面导航栏搜索框默认边框颜色
    '--workbench-search-app-border-color': '#39393f',
    // 工作桌面导航栏搜索框默认背景色
    '--workbench-search-app-bg-color': '#2b2b30',
    // 工作桌面导航栏搜索框默认文字颜色
    '--workbench-search-app-input-color': '#dfdfdf',
    // 工作桌面导航栏搜索框focus颜色
    '--workbench-search-app-focus-color': '#dfdfdf',
    // 导航栏图标颜色 集团切换
    '--workbench-nav-icon-color': '#ddd',
    // 集团切换 消息中心 等下拉区域背景色
    '--workbench-nav-drop-down-bg-color': '#2b2b30',
    // 集团切换 消息中心 等下拉区域阴影
    '--workbench-nav-drop-down-box-shadow-color': '0 2px 8px 0 #000',
    // 集团切换 消息中心 等下拉区常规文字颜色
    '--workbench-nav-drop-down-title-color': '#d9d9d9',
    // 集团切换 消息中心 等下拉区域禁用或置灰文字颜色
    '--workbench-nav-drop-down-title-disable-color': '#aeaeae',
    // 集团切换 消息中心 等下拉区每一项hover背景色
    '--workbench-nav-drop-down-item-hover-bg-color': '#37373c',
    // 桌面配置顶部页签文字 底部横线 颜色
    '--workbench-desktop-setting-title-color': '#d9d9d9',
    // ant-tabs-bar border颜色
    '--workbecnch-ant-tabs-bar-border-bottom-color': '#39393f',
    // 导航栏border-bottom 颜色
    '--workbench-nav-border-bottom-color': '#35353c',
    // 桌面背景色
    '--workbench-home-bg-color': '#0f0f0f',
    // 桌面配置 分组页签背景色
    '--workbench-home-tab-bg-color': '#292930',
    // 桌面配置 当前分组页面背景色
    '--workbench-home-current-tab-bg-color': '#e14c46',
    // 桌面配置 非当前分组页签文字颜色
    '--workbench-home-tab-title-color': '#ccc',
    // 桌面配置 当前分组页签文字颜色
    '--workbench-home-tab-current-title-color': '#ddd',
    // 部件和应用背景色
    '--workbench-app-bg-color': '#27282f',
    // 部件和应用标题颜色
    '--workbench-app-title-color': '#ccc',
    // 部件标题 未选中颜色
    '--workbench-app-title-color1': '#A5A5A5',
    // 应用菜单 新增图标 颜色
    '--workbench-allapps-add-icon-color': '#ccc',
    // 新手引导 背景色1
    '--workbench-novide-bg1': '#353841',
    // 新手引导 背景色2
    '--workbench-novide-bg2': '#31333c',
    // 桌面分组文字颜色
    '--workbench-app-container-title-color': '#888',
    // 常用应用 应用hover背景色
    '--workbench-app-group-item-hover-bg': '#31313c',
    // 常用应用 图标hover背景色
    '--workbench-app-group-icon-hover-bg': '#31313c',
    // 常用应用 应用图标背景色
    '--workbench-app-icon-content-bg': '#31313c',
    // 全部应用 整体 背景色
    '--workbench-allapps-bg': '#25252a',
    // 全部应用 左侧整体背景色
    '--workbench-allapps-sider-bg': '#2d2d32',
    // 全部应用 右侧整体背景色
    '--workbench-allapps-right-bg': '#2d2d32',
    // 应用菜单 标题 颜色
    '--workbench-allapps-title-color': '#d9d9d9',
    // 应用菜单 竖线颜色
    '--workbench-allapps-line-color': '#3271ff',
    // 应用菜单 hover 背景色
    '--workbench-allapps-item-hover-bg': '#494954',
    // 应用菜单 应用 文字颜色1
    '--workbench-allapps-title-color1': '#d9d9d9',
    // 应用菜单 文字颜色2
    '--workbench-allapps-title-color2': '#999',
    // 应用菜单 领域 hover背景色
    '--workbench-allapps-left-item-hover-bg': 'none',
    // 个人中心文字hover颜色
    '--workbench-user-info-hover': '#eb5230',
    // 个人中心侧拉背景色
    '--workbench-user-bg': '#35353c',
    // 个人中心 每一块背景色
    '--workbench-user-item-bg': '#38373d',
    // 主题hover背景色
    '--workbench-skin-hover-bg': '#25252a',
    // 个人中心 文字颜色
    '--workbench-user-text-color': '#a1a2a2',
    // 个人中心 下划线颜色
    '--workbench-user-line-bg': '#5c5c66',
    // 页面 标题区背景色
    '--workbench-page-header-bg': '#39393f',
    // 页面 底部背景色
    '--workbench-page-footer-bg': '#25252a',
    // 页面 标题区文字颜色
    '--workbench-page-header-text-color': '#d9d9d9',
    // 页面 左侧整体背景色
    '--workbench-page-left-bg': '#27272a',
    // 页面 左侧 每一块 背景色
    '--workbench-page-left-item-bg': '#38373d',
    // 页面 左侧 图标 hover 背景色
    '--workbench-page-left-icon-hover-bg': '#25252a',
    // 页面 左侧 每一块字体颜色
    '--workbench-page-text-color': '#a1a2a2',
    // 页面 右侧 整体背景色
    '--workbench-page-right-bg': '#25252a',
    // 页面 左侧 每一块边框
    '--workbench-page-left-item-border': 'none',
    // 页面 右侧 border-right
    '--workbench-page-right-border-color': '#393941',
    // 页面 左侧 线颜色
    '--workbench-page-left-line-color': '#5c5c66',
    // 桌面配置 整体背景色
    '--workbench-desktop-setting-bg': '#0f0f0f',
    // 桌面配置 编辑态 当前分组页签文字颜色
    '--workbench-home-tab-editable-current-title-color': '#d9d9d9',
    // 桌面配置 左侧侧拉收起时背景色
    '--workbench-home-addapp-close-bg': '#696979',
    // 桌面配置 左侧侧拉展开时背景色
    '--workbench-home-addapp-expand-bg': '#696979',
    // 桌面配置 左侧侧拉收起时边框色
    '--workbench-home-addapp-close-border': '#696979',
    // 桌面配置 左侧侧拉展开时边框色
    '--workbench-home-addapp-expand-border': '#696979',
    // 桌面配置 左侧侧拉收起时加号图标
    '--workbench-home-addapp-icon-color': '#f1f1f1',
    // 桌面配置 每组 右侧图标
    '--workbench-home-item-header-icon': '#ccc',
    // 桌面配置 应用 部件右上角背景色
    '--workbench-home-app-bg': '#494954',
    // 桌面配置 应用 部件右上角图标 颜色
    '--workbench-home-app-icon': '#8e99b5',
    //桌面配置 左侧打开时背景色
    '--workbench-desktop-open-bg': '#26262b',
    //桌面配置 左侧打开时添加图标颜色
    '--workbench-desktop-open-add-icon': '#f1f1f1',
    //桌面配置 左侧打开时 每个应用hover border
    '--workbench-desktop-open-app-hover-border-color': '#fff',
    //桌面配置 左侧打开时 顶部tabs背景色
    '--workbench-desktop-open-tabs-bg': '#1c1c20',
    //桌面配置 左侧打开时 顶部tabs当前背景色
    '--workbench-desktop-open-tabs-current-bg': '#26262b',
    //桌面配置 左侧打开时 顶部tabs当前border
    '--workbench-desktop-open-tabs-current-border': 'transparent',
    //桌面配置 左侧打开时 搜索框背景色
    '--workbench-desktop-open-search-box-bg': '#27282f',
    //桌面配置 左侧打开时 搜索框背景色1
    '--workbench-desktop-open-search-box-bg1': '#2a2a2f',
    //桌面配置 左侧打开时 搜索框hover 清楚图标
    '--workbench-desktop-open-search-box-hover-icon': '#848484',
    //桌面配置 左侧打开时 搜索框边框颜色
    '--workbench-desktop-open-search-box-border': '#39393f',
    //桌面配置 左侧打开时 标题区域背景色
    '--workbench-desktop-open-item-title-bg': '#2e2e33',
    //桌面配置 左侧打开时 区域背景色
    '--workbench-desktop-open-item-bg': '#2b2b30',
    //桌面配置 左侧打开时 标题名称颜色
    '--workbench-desktop-open-test1': '#d9d9d9',
    //桌面配置 左侧打开时 节点名称颜色
    '--workbench-desktop-open-test2': '#a1a2a2',
    // 业务设置 左侧字体颜色
    '--workbench-test-color1': '#a5a5a5',
    // 勿扰模式弹框 
    '--workbench-disturbModal-ant-alert-bg': '#2b2b30',
    // 勿扰模式弹框 
    '--workbench-disturbModal-ant-alert-color': '#a1a2a2',
    // 标准页面 label颜色
    '--workbench-nc-page-label': '#b0b0b0',
    // 邮箱修改弹框 输入框背景色
    '--workbench-userinfo-modal-ant-input-bg': '#303036',
    // 邮箱修改弹框 输入框边框
    '--workbench-userinfo-modal-ant-input-border': '#3d3d47',
    // 邮箱修改弹框 输入框颜色
    '--workbench-userinfo-modal-ant-input-color': '#bdbdbd',
    // 账户设置 每一项边框颜色
    '--workbench-userinfo-item-border-color': '#39393f',
    // 桌面配置底部背景色
    '--workbench-home-footer-bg': '#25252b',
    // 桌面配置底部border
    '--workbench-home-footer-border': '#39393f',
    // 桌面配置 新增分组按钮
    '--workbench-home-add-group-bg': '#202022',
    // antd-dropdown 背景色
    '--workbench-ant-dropdown-menu-bg': '#222226',
    // antd-dropdown border
    '--workbench-ant-dropdown-menu-border': '#39393f',
    // antd-dropdown 每一项hover 颜色
    '--workbench-ant-dropdown-menu-item-hover': '#494954',
    // 常用应用 左侧边框
    '--workbench-drag-modal-left-border': '#39393f',
    // 常用应用 下拉图标
    '--workbench-drag-modal-icon-down': '#ccc',
    // 常用应用 下拉框颜色
    '--workbench-drag-modal-cascader-color': '#888',
    // 页面 头部区域border-bottom
    '--workbench-page-header-border': '#39393f',
    // 模板设置 标题区border颜色
    '--workbench-template-setting-page-header-border': '#39393f',
    // 模板设置 左右侧区域border
    '--workbench-template-setting-page-border1': '#39393f',
    // 模板设置 左右区域背景色
    '--workbench-template-setting-page-bg1': '#202022',
    // 模板设置 中间区域背景色
    '--workbench-template-setting-page-bg2': '#27272a',
    // 模板设置 label颜色
    '--workbench-template-setting-page-label': '#b0b0b0',
    // antd input 
    '--workbench-ant-input-bg': '#36373c',
    // antd input 
    '--workbench-ant-input-border': '#3d3d47',
    // antd input 
    '--workbench-ant-input-color': '#fff',
    // antd input 
    '--workbench-ant-input-hover-border': '#8cc6ff',
    //模板设置 文字
    '--workbench-template-setting-page-color': '#9b9b9b',
    //模板设置 可选区域背景色
    '--workbench-template-setting-page-bg3': '#494954',
    //模板设置 hover color
    '--workbench-template-setting-page-hover-color': '#d9d9d9',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg4': '#27272a',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg5': '#27272a',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg6': '#2a2a2f',
    //模板设置 文字
    '--workbench-template-setting-page-color1': '#bdbdbd',
    //模板设置 border
    '--workbench-template-setting-page-border2': '#39393f',
    //模板设置 文字
    '--workbench-template-setting-page-color2': '#bdbdbd',
    // 模板设置 弹框
    '--workbench-template-setting-page-modal-color1': '#2b2b30',
    // 模板设置 弹框
    '--workbench-template-setting-page-modal-color2': '#2b2b30',
    // 图片透明度
    '--workbench-img-opacity': '.5',
    // 桌面配置 button border
    '--workbench-desktop-footer-border': '#39393f',
    // 应用菜单 三级菜单背景色
    '--workbench-allapps-bg1': 'rgba(60,60,67,.5)',
    // 导航栏工作台选中激活颜色
    '--workbench-nav-active': mixinFreeColor('#35353c', 0.8),
    //搜索栏中主色调设为白色
    '--workbench-nav-search-color': '#fff',
    //搜索栏背景色
    '--workbench-nav-search-bg': 'rgba(255, 255, 255, 0.1)',
    //搜索栏边框颜色
    '--workbench-nav-border-color': 'rgba(255,255,255,0.2)',
    //搜索栏其他色边框聚焦颜色
    '--workbench-nav-border-color-focus': 'rgba(255,255,255,0.5)',
    //搜索栏边框hover颜色
    '--workbench-nav-border-color-hover': 'rgba(255,255,255,0.2)',
    '--workbench-nav-active': mixinFreeColor('#35353c', 0.85),
    //搜索栏竖线透明度
    '--workbench-nav-search-shuxian-opacity': 0.2,
    //搜索栏select框背景色
    '--workbench-nav-select-bg-color': 'rgba(53,53,60)',
    //搜索栏select框文字hover时的颜色
    '--workbench-nav-select-text-color': 'rgba(73, 73, 84)',
    //搜索框联想面板的字体颜色
    '--workbench-nav-search-more-color': '#b0b0b0 ',
    //搜索栏下拉框图标颜色
    '--workbench-nav-select-drop-color': 'rgba(255,255,255,0.8)',
    //搜索栏下拉选中字体颜色
    '--workbench-nav-select-drop-text-color': 'rgba(73,73,84)',
    //搜索栏暂无数据搜索图标颜色
    '--workbench-nav-search-icon-sousuo1-color': '#999999',
    //搜索框联想面板标题背景颜色
    '--workbench-nav-title-bg-color': 'rgba(70,70,77)',
    //搜索框联想面板的分类标题颜色
    '--workbench-nav-search-title-color': '#b0b0b0',
    //搜索栏横线颜色
    '--workbench-nav-search-hr-color': 'rgba(76,76,87)',
    //内部页签标签栏背景色
    '--workbench-tab-wrapper-bg': '#1A1A1C',
    //内部页签标签栏背景下划线
    '--workbench-tab-bottom-color': '#D7332C',
    //内部页签选中字体颜色
    '--workbench-tab-active-color': '#D7332C',
    // 面包屑首页下拉图标颜色
    '--workbench-breadcrumb-home-icon-c': '#fff',
    // 面包屑首页下拉图标透明度
    '--workbench-breadcrumb-home-icon-o': 0.9,
    // 面包屑首页下拉图标边框透明度
    '--workbench-breadcrumb-home-icon-bo': 0.6,
    // 内部页签右侧节点列表下拉背景色
    '--workbench-inside-tab-dropdown-bk': 'rgba(53,53,60)',
    // 内部页签右侧节点列表下拉item hover色
    '--workbench-inside-tab-dropdown-item-hover': 'rgba(70,70,77)',
    // tab右键文字颜色
    '--workbench-inside-tab-dropdown-text': '#c9c9c9',
    // ant-modal相关
    '--workbench-ant-modal-content-color': '#222226',
    '--workbench-ant-modal-header-bg': '#2b2b30',
    '--workbench-ant-modal-border-color': '#39393f',
    '--workbench-subjectsetting-preview-search-area': '0f0f0f',
    // 应用hover时阴影色
    '--workbench-app-hover-shadow': '#0f0f0f',
    // ant-form-extra
    '--workbench-ant-form-extra-color': '#888888',
    // 背景设置背景色
    '--workbench-background-setting-bg': '#27272A',
    // 个人中心 设置 按钮
    '--workbench-disturb-setting-btn': '#5790ff',
    // 菜单项边框色
    '--workbench-allapps-border-color': 'transparent',
    // 集团下拉hover背景色
    '--workbench-group-list-hover-bg-color': "#37373D",
    // 集团下拉选中背景色
    '--workbench-group-list-select-bg-color': "#454550",
    // 基于主色hsl格式，l值为93
    '--workbench-color-primary-l93': "#46464D",
    '--workbench-color-primary-l95': "#E04340",
};